module.exports = __webpack_public_path__ + "img/Steor-Icons-17.501f69a2.svg";